<script lang="ts" setup>
import { ChatScene } from "@/types/chat";
import { useMate } from "@/stores/mate";
import { replacePlaceHolder } from "@/components/mobile/chat/mode/util";
import escapeHtml from "@/modules/escape-html";
import { marked } from "marked";

const props = withDefaults(
  defineProps<{
    selected?: boolean;
    targetMate: Mate;
    chatScene: ChatScene;
  }>(),
  {
    selected: false,
  }
);

const mateStore = useMate();

function parsePrompt(txt: string) {
  if (!txt) return "";
  const msg = replacePlaceHolder(
    txt,
    props.targetMate.name ?? "",
    mateStore.currentMate?.name ?? ""
  );
  const content = escapeHtml(msg);
  return marked.parse(content);
}
</script>
<template>
  <div
    :class="{
      '': !selected,
      'border-primary': selected,
    }"
    class="flex gap-2 border p-2 h-32 rounded cursor-pointer"
  >
    <UserAvatar :avatar-url="chatScene.media?.url" class="h-28 shrink-0" />
    <div class="overflow-y-auto flex-grow text-xs flex flex-col gap-2">
      <div v-if="chatScene.scenario" class="flex flex-col gap-1">
        <span class="font-semibold flex items-center gap-1">
          <i class="iconify mingcute--book-2-line" />
          {{ $t("User.mate.chat.scenario") }}
        </span>
        <div class="chat-container" v-html="parsePrompt(chatScene?.scenario)" />
      </div>
      <div v-if="chatScene.greeting" class="flex flex-col gap-1">
        <span class="font-semibold flex items-center gap-1">
          <i class="iconify mingcute--message-2-line" />
          {{ $t("User.mate.chat.greetingMessage") }}
        </span>
        <div class="chat-container" v-html="parsePrompt(chatScene.greeting)" />
      </div>
      <div
        v-if="!chatScene.scenario && !chatScene.greeting"
        class="flex items-center justify-center h-full text-sm"
      >
        {{ $t("Message.noGreetingIntro") }}
      </div>
    </div>
  </div>
</template>
